import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,{staticClass:"mb-4"},[_c(VCardTitle,[_vm._v(_vm._s(_vm.$t('Perfil')))])],1),_c(VRow,{staticClass:"mb-4"},[_c(VCol,{attrs:{"cols":"12","md":"12","lg":"12"}},[_c('profile-bio-panel',{attrs:{"user-data":_vm.userData},on:{"reload-data":_vm.getUserData}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }